import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const messageBird = defineConnector({
  identifier: "messageBird",
  name: "MessageBird",
  tagLine: "Messaging and communications APIs",
  logo,
  protocol: "http",
  tags: ["communication"],
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.accessKey,
        scheme: "AccessKey",
      },
    ]),
  steps: [
    {
      title: "Get an access key",
      items: [
        {
          kind: "markdown",
          content:
            "In MessageBird, create or copy a live API access key. The REST API sends it in the `Authorization` header using the `AccessKey` scheme.",
        },
      ],
    },
    {
      title: "Enter your access key",
      items: [
        {
          kind: "input",
          label: "Access key",
          required: true,
          target: { kind: "secrets", field: "accessKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://rest.messagebird.com/balance",
  },
  defaultUrlPattern: () => "https://rest\\.messagebird\\.com/.*",
});
